import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "query-builder" }

import group from "@AdvancedSearch/components/QueryBuilder/Group.vue";
import { useContentLanguages } from "@common/composable/useMetaDataStore";
import { FetchableData, QueryBuilderData } from "@medapro-types/AdvancedSearch/components/QueryBuilder";
import advancedSearchApi from "@services/advancedSearch";
import emitter from "tiny-emitter/instance";
import { Ref, inject, onMounted, provide, reactive, ref, watch } from "vue";
import { naturalSort } from "@util/naturalSort";
import { useI18n } from "vue-i18n";

//#region General
type ViewModel = {
  localModel: QueryBuilderData;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'QueryBuilder',
  props: {
    value: {}
  },
  emits: ["input"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const { t: $t } = useI18n();

const { primaryLanguageCode: primaryLanguageCode, localizedLanguages: localizedLanguages } = useContentLanguages();

//#endregion

//#region ViewModel
const vm = reactive<ViewModel>({ localModel: props.value });
//#endregion

//#region Provide
const fetchedData = ref<FetchableData | null>(null);

provide("fetchedData", fetchedData);
provide("localizedLanguages", localizedLanguages);

const isBusy = inject<Ref<boolean>>("advancedSearchIsBusy");
//#endregion

const fetchAndSetData = async () => {
  try {
    setBusyState(true);
    const searchTypes = await advancedSearchApi.getSearchTypes(primaryLanguageCode.value);
    const searchTypesToBeSorted = ["assignedTo", "createdBy", "changedBy"];

    for (const searchType of searchTypes) {
      if (searchType && searchTypesToBeSorted.includes(searchType.searchType) && Array.isArray(searchType.selection)) {
        searchType.selection = naturalSort(searchType.selection, "name", false);
      }

      if (searchType.searchType === "assignedTo") {
        const unassignEntry = { name: `<${$t("unassigned")}>`, userId: "" };
        searchType.selection.unshift(unassignEntry);
      }
    }
    fetchedData.value = searchTypes;
    setBusyState(false);
  } catch (error) {
    emitter.emit("global-error", { type: "api", exception: error });
  }
};

watch(
  () => props.value,
  (nv) => {
    vm.localModel = nv;
  }
);

//#region Busy
const setBusyState = (busyValue: boolean) => {
  if (isBusy) {
    isBusy.value = busyValue;
  }
};
//#endregion

//#region Update vModel
watch(
  () => vm.localModel,
  (nv) => {
    emits("input", nv);
  },
  { deep: true }
);
//#endregion

onMounted(async () => {
  await fetchAndSetData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(group, {
      modelValue: vm.localModel,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vm.localModel) = $event)),
      class: "root",
      path: "#root#"
    }, null, 8, ["modelValue"])
  ]))
}
}

})